import { lazy, Suspense } from 'react';
import data from '@emoji-mart/data';

const Picker = lazy(() => import('@emoji-mart/react'));

type Props = {
  onSelect: (e: { id: string; native: string }) => void;
  onClose: () => void;
};

export function EmojiPickerSheet({ onSelect, onClose }: Props) {
  return (
    <div className="absolute bottom-full left-0 mb-2 z-50 shadow-xl rounded-lg overflow-hidden">
      <Suspense fallback={<div className="bg-popover p-4 text-sm">Loading…</div>}>
        <Picker
          data={data}
          onEmojiSelect={(e: { id: string; native: string }) => onSelect(e)}
          onClickOutside={onClose}
          theme="auto"
          previewPosition="none"
        />
      </Suspense>
    </div>
  );
}
